module.exports = __webpack_public_path__ + "img/measurement_info_left_feet_back_animated.ea25c0d8.gif";